import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../common/utils'
import Loader from '../../../common/loader/Loader'
import Card from '../../../common/card/Card'
import LicensesStoreTable from './LicensesStoreTable'
import Modal from '../../../common/modal/Modal'
import MicroModal from 'micromodal'
import Button from '../../../common/button/Button'
import Icons from '../../../common/icons/Icons'

const LicensesStore = ({ teamData, productRenewed, infosMembersAssigned, setCurrentModalLoading, total, membersSelection }) => {

  const params = useParams()
  const teamId = params.team_id
  const [finalPrice, setFinalPrice] = useState(0)
  const [disableCheckout, setDisableCheckout] = useState(false)

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['get_org_store_licenses'],
      queryFn: requestOrgLicenses,
      refetchOnWindowFocus: false
  }, queryClient)

  async function requestOrgLicenses() {
    const {
      group_dashboard: { nonce, base }
    } = window
    let url = base + 'membersync/licensing/v1/org/shop/products'

    const res = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify({
        filter: 'license',
        product_renewed: productRenewed,
        org: teamId
      }),
      headers: {
        'X-WP-Nonce': nonce,
        'Content-type': "application/json"
      },
      credentials: 'same-origin',
      processData: false,
      contentType: false,
    })

    if ( !res.ok ) throw Error(res.statusText)

    const resultJSON = await res.json()
    return resultJSON.response
  }

  useEffect(() => {
    setCurrentModalLoading( isLoading )
  }, [isLoading])

  if( isLoading || isPending || isFetching ) {
    return
  }

  if( isError ){
    return (
      <Card> 
        <strong> { error.message } </strong> 
      </Card>
    )
  }

  if ( data.length === 0 ) {
    return (
      <>
      </>
    )
  }

  const confirmModalId = "msync-confirm-assign-licenses-after-purchase-" + data.renewal.product[0]
  const modalId = "msync-licenses-store-" + data.renewal.product[0]

  const prepareMembersRenewedSelectChoices = () => {
    let membersChoices = []
    infosMembersAssigned.map((member) => {
      let currentMember = {}
      currentMember = {value: member.actor_id, label: member.username}
      membersChoices.push(currentMember)
    })
    
    return membersChoices
  }

  return (
    <Modal
      modalId={modalId} 
      buttonTitle="" 
      modalHeading='Licenses store'
      modalClassNames={ 'msync-assign-licenses-custom-modal msync-assign-licenses-custom-modal-border'}
    >
      <main className="msync-modal__body">
        <div>
          <div>
            {
              (data.products).find((element)  => element.id === data.renewal.product[0]) === undefined && <div className='msync-insufficient-licenses'>
                <div className='msync-insufficient-licenses-title'>
                  <Icons type='warning' /> Product availability notice
                </div>
                <div>
                  The recommended product has been automatically selected for you, because the product you initially purchased has been archived or deleted.
                </div>
              </div>
            }
          </div>
          <span>Available products</span>
          { data.products && data.products.length !== 0 && <LicensesStoreTable 
            licensesData={ data } 
            newPrice={(value) => setFinalPrice(value)}  
            setDisableCheckout={(value) => setDisableCheckout(value)}
            productRenewed={data.renewal}
            membersRenewedSelect={prepareMembersRenewedSelectChoices()}
            membersRenewed={infosMembersAssigned}
            total={total}
            membersSelection={membersSelection}
          /> }
        </div>
        <div>
          Total : {finalPrice}
        </div>
        <footer className="modal__footer">
          <Button
            className="msync-button--is-style-outline msync-button--is-theme-destructive"
            type="button"
            name="Cancel"
            onClick={ () => MicroModal.close(modalId) }
            aria-label="Close this dialog window"
          />
          <Button
            className="msync-primary-btn"
            onClick={ async () => {
              MicroModal.show(confirmModalId)
            }}
            name="Confirm assignment"
            isDisabled={ disableCheckout }
          />
        </footer>
      </main>
    </Modal>
  )

}

export default LicensesStore
